




































import { Component, Model, Vue } from 'vue-property-decorator';

@Component
export default class SearchPopover extends Vue {
    @Model('input', { type: String }) public value!: string;

    public menu = false;

    public enterSearch(event: any) {
        this.$emit('search', event);
    }
}
